/**
 * This portal has no object-storage/multipart upload widget (out of scope
 * for a staff console built in one pass — see CLAUDE.md's "Files: multipart
 * -> object storage -> Document record with SHA-256" convention, which
 * assumes an upload step this app doesn't implement). Every backend
 * endpoint that accepts a supporting document still requires a real
 * `sha256` alongside a `docRef`, so every document-attaching form in this
 * app computes a genuine SHA-256 client-side (Web Crypto SubtleCrypto) over
 * the reference text the officer enters, rather than fabricating a hash
 * string. In production this would be the uploaded file's own hash; here it
 * lets every screen still call the real endpoint with a real, valid,
 * deterministic 64-char hex digest instead of a placeholder.
 */
export async function sha256Hex(input: string): Promise<string> {
  const data = new TextEncoder().encode(input);
  const digest = await crypto.subtle.digest('SHA-256', data);
  return Array.from(new Uint8Array(digest))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
}
